import React from "react";
import TablaSucursal from "js/components/TablaSucursal";

export const Sucursal = props => {
  return <TablaSucursal />;
};

export default Sucursal;
